import ActressList from "../views/actressManagement/actressList";
import FilterItems from "../views/actressManagement/filterItems";
import CrowdFundingList from "../views/actressManagement/crowdFundingList";
import Main from "../views/main";

const ActressRouter = {
  path: "/actress",
  component: Main,
  title: "女优管理",
  icon: "el-icon-s-promotion",
  meta: {
    keepAlive: true,
  },
  children: [
    {
      path: "/actressList",
      component: ActressList,
      name: "actressList",
      title: "女优列表",
      meta: {
        title: "女优列表",
        keepAlive: true,
      },
    },
    {
      path: "/filterItems",
      component: FilterItems,
      name: "filterItems",
      title: "女优筛选项",
      meta: {
        title: "女优筛选项",
        keepAlive: true,
      },
    },
    // {
    //   path: "/crowdFundingList",
    //   component: CrowdFundingList,
    //   name: "crowdFundingList",
    //   title: "众筹列表",
    //   meta: {
    //     title: "众筹列表",
    //     keepAlive: true,
    //   },
    // },
  ],
};
export default ActressRouter;
